import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {
    createCopyLink,
    generateUUID2, getImagePathWithSvg,
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    getLocalFilePath,
    isImage, isMdFileElement,
    isString,
    isStringNullOrEmpty
} from "../../utils";
import {EVENT_CLOSE_IMAGE_ACTION, EVENT_TEST_ONDRAG_NOTE, FROM_DIALOG, KEY_FILE_DIR, MAX_Z_INDEX} from "../../Const";
import {Dropdown, Modal ,Tooltip} from "antd";
import { t } from "i18next";
import global from "../../global";
import {atomCardItemPointerEvent} from "../Home/HomeIndex";
import {useAtom} from "jotai";
import {isStickyNotesElement, isTextElement} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {
    handleClipboard,
    handleTransformPastedHTML,
    handleTransformPastedText
} from "@/components/EditorV2/TiptapCommonHandle";
import {imgServer} from "@/components/EditorV2/imgServer";
import {updateTiptapDoc} from "@model/tiptapDoc";
import {postMessage} from "@/common/event";
import {mutateElement} from "../../../@excalidraw/packages/excalidraw";
import {updateCard} from "@model/card";
import {TextTiptapCache} from "../../../@excalidraw/packages/excalidraw/components/TextTiptap/TextTiptap";
import {BubbleMenu, EditorContent, useEditor } from "@tiptap/react";
import {getTiptapExtension} from "@/components/EditorV2/TiptapTiptapExtension";
import ImgAction from "@/components/EditorV2/ImgAction";
import {getFontFamilyString} from "../../../@excalidraw/packages/excalidraw/utils";
import './DialogTiptapTextEditor.css'
import Global from "@/global";
import style from "@/components/EditorV2/index.module.less";
import ColorPickers from "@/components/EditorV2/ColorPicker";
import {isInSingleFloatWindow} from "@/Utility";
import TurnNewCard from "@/components/EditorV2/TurnNewCard/TurnNewCard";
import HighlightPicker from "@/components/EditorV2/HighlightPicker/HighlightPicker";
import {getBlockMenu} from "@/components/EditorV2/BlockMenu/BlockMenu";
import MdEditor from 'for-editor'
import { ipcInvoke } from "@/common/ipc";

const DialogTiptapTextEditor = forwardRef((props:{element:any,onCloseCallback:any},ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        getIsPin:getIsPin,
        showOrHidden:showOrHidden
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [size,setSize] = useState({width:document.body.clientWidth*0.7,height:document.body.clientHeight*0.8})
    const [isPin,setIsPin] = useState(false);
    const [hasMaskLayer,setHasMaskLayer] = useState(true);
    const [data,setData] = useState<any>();

    const nWidth = 615;
    let nHeight = 380;
    const [x, setX] = useState((document.body.clientWidth-nWidth)*0.5); // div 的左上角 x 坐标
    const [y, setY] = useState((document.body.clientHeight - nHeight)*0.5); // div 的左上角 y 坐标
    const [pointerEvents,setPointerEvents] = useState('all');
    const [cardItemPointerEvent,setCardItemPointerEvent] = useAtom(atomCardItemPointerEvent);
    //拖拽
    const mIsDragging = useRef<any>(false);
    const offset = useRef<any>({x:0,y:0});
    const mResizing = useRef(null);
    const initialMousePos = useRef<any>({ x: 0, y: 0});
    const [dialogSize,setDialogSize] = useState<any>({width:nWidth,height:nHeight});
    const draggleRef = useRef<HTMLDivElement>(null!);
    const dragTransform = useRef<any>('translate(0px, 0px)');
    const [isVisible,setIsVisible] = useState(true);
    const [isMdSplitView,setIsMdSplitView] = useState(false);
    const mEditor = useRef<any>(null);
    const divContainerRef = useRef(null);
    const mEditorContentRef = useRef(null);
    const mIsTiptapCreateOk = useRef(false);
    // 保存Markdown文本内容
    const [mdContent, setMdContent] = useState('');
    const mTimeoutId = useRef<any>(0);
    const mInputRef = useRef(null);

    useEffect(()=>{
        if (global.g_isCtrlPressed){
            setIsPin(true);
            setHasMaskLayer(false);
        }

        setData(props.element);

        document.body.addEventListener('mousemove',handleMouseMove);
        document.body.addEventListener('mouseup',handleMouseUp);


        if (mInputRef.current){
            setTimeout(()=>{
                mInputRef.current?.focus();
            },200)
        }

        return ()=>{
            document.body.removeEventListener('mousemove',handleMouseMove);
            document.body.removeEventListener('mouseup',handleMouseUp);
            global.g_mapMdContentCache = {};
        }
    },[])

    useEffect(() => {
        if (isMdFileElement(props.element)){
            //读取这个文件，然后设置...
            let szFileDir = localStorage.getItem(KEY_FILE_DIR);
            let szFilePath = props.element.customData.generationData.fileName;
            if (!props.element.customData.generationData.isAbsolutePath){
                szFilePath = szFileDir + szFilePath;
            }
            if (global.g_mapMdContentCache[props.element.id]){
                setMdContent(global.g_mapMdContentCache[props.element.id]);
                // ipcInvoke('read-file-absolute-path-text',{filePath:szFilePath})?.then(res=>{
                //     setMdContent(res);
                // })
            }else{
                ipcInvoke('read-file-absolute-path-text',{filePath:szFilePath})?.then(res=>{
                    setMdContent(res);
                })
            }
        }
    }, [props.element]);

    const arrayExtensions = [
        ...getTiptapExtension(mEditor.current,'stickynote'),
        getBlockMenu('stickynote'),
    ]

    const editor = useEditor({
        autofocus: false,
        injectCSS: true,
        editable: true,
        extensions: arrayExtensions,
        editorProps: {
            attributes: {
                // class: '',
            },
            handleDOMEvents:{
                keydown:(view,event)=>{
                    if (event.key == '@'){
                        window.showPopupCardList(mEditor.current);
                    }else if (event.key == KEYS.BACKSPACE){
                        window.closePopupCardList();
                    }
                },
                dragstart:(view,event)=>{
                    event.preventDefault();
                    event.stopPropagation();
                },
            },
            clipboardTextParser(text, context, plain, view) {
                if (mEditor.current) {
                    return handleClipboard(mEditor.current,text);
                }
            },
            transformPastedText(text, plain, editorView) {
                return handleTransformPastedText(text, plain, editorView);
            },
            transformPastedHTML(html,editorView) {
                return handleTransformPastedHTML(html,editorView,props.element.id,()=>{

                })
            },
            handleClick(e, r, k) {
                //取消选中
                mEditor.current.chain().focus().setTextSelection(r).run();

                //记录点击的位置
                const divScroll = document.getElementById('div-cardedit-scroll-'+props.element.id);
                global.g_mapCardPos[props.element.id] = {pos:r,scroll:divScroll?.scrollTop || 0};

                postMessage(EVENT_CLOSE_IMAGE_ACTION);
                window.closePopupCardList();
            },
        },
        onUpdate(editor0) {
            if (mIsTiptapCreateOk.current){
                let szHtml = imgServer.parserImgFromHtml(editor0.editor?.getHTML() as string,props.element.id);
                mutateElement(props.element,{value:szHtml});
                updateTiptapDoc({id:props.element.id,doc:szHtml});
                window.globalRefreshList('on_update_html_'+props.element.id,szHtml);
            }
        },
        onSelectionUpdate(editororororororor) {

        },
        onCreate(editor0) {
            mEditor.current = editor0.editor;
            editor0.editor.commands.setContent(props.element.value);
            // editor0.editor.commands.setTextSelection(0);
            editor0.editor.commands.focus('end');
            mIsTiptapCreateOk.current = true;
        },
        onFocus(editor){

        },
        onBlur(editor) {

        },
        onDestroy() {

        },
        parseOptions: {
            preserveWhitespace: 'full',
        },
    });


    const onShowDialog = (data:any)=>{
        setIsShowDialog(true);
        setData(data);
        setHasMaskLayer(window.getDialogPinCount() == 0);
    }

    const getIsPin = ()=>{
        return isPin;
    }

    /**
     * 显示或隐藏
     */
    function showOrHidden(){
        if (global.g_isHiddenAllFloatWin){
            setIsVisible(false)
        }else{
            setIsVisible(true)
        }
    }

    const handleMouseDown = (corner) => (e) => {
        mResizing.current = (corner);
        initialMousePos.current = ({ x: e.clientX, y: e.clientY });
        e.preventDefault();
        e.stopPropagation();
    };

    const handleMouseMove = (e) => {
        if (mResizing.current){
            e.stopPropagation();
            setPointerEvents('none');
            setCardItemPointerEvent('none');

            const rect = draggleRef.current.getBoundingClientRect();
            const deltaX = e.clientX - initialMousePos.current.x;
            const deltaY = e.clientY - initialMousePos.current.y;
            let nWidth = 0,nHeight =0;

            switch (mResizing.current) {
                case 'top-left':
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setX(rect.left + deltaX);
                    setY(rect.top + deltaY);
                    break;
                case 'top-right':
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setY(rect.top + deltaY);
                    break;
                case 'bottom-left':
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    setX(rect.left + deltaX);
                    break;
                case 'bottom-right':
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    break;
                case "left":
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = rect.height;
                    setX(rect.left + deltaX);
                    break;
                case "top":
                    nWidth = rect.width;
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setY(rect.top + deltaY);
                    break;
                case "right":
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = rect.height;
                    break;
                case "bottom":
                    nWidth = rect.width;
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    break;
                default:
                    break;
            }

            // if (nWidth < 520){
            //     nWidth = 520;
            // }
            // if (nHeight < 600){
            //     nHeight = 600;
            // }

            setDialogSize({
                width: nWidth,
                height: nHeight,
                maxHeight: '100vh'
            })

            initialMousePos.current = ({ x: e.clientX, y: e.clientY });
        }

        if (mIsDragging.current) {
            setX(e.clientX - offset.current.x);
            setY(e.clientY - offset.current.y);
        }

    };

    const handleMouseUp = () => {
        mResizing.current = (null);
        setPointerEvents('all');
        setCardItemPointerEvent('all');
    };

    const getFontFamily = ()=>{
        let fontFamily = '';
        if (!props.element.fontFamily){
            fontFamily = '"Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
        }else{
            fontFamily = `${getFontFamilyString({fontFamily: props.element.fontFamily})}`;
        }
        return fontFamily;
    }

    /**
     * 显示链接
     */
    const showLink = ()=>{
        const text = editor.state.selection.content()?.content?.content?.[0]?.textContent;
        global.g_newCardTitle = text;

        let link = editor.getAttributes('link').href

        //关闭editor的焦点，以防止粘贴图片到库中的问题。。。
        editor.commands.blur();

        window.showDialogLink(link, 'card', (item) => {
            if(!item) {
                editor.commands.unsetLink()
                return;
            };

            if (isString(item.link)){
                if(!item.link?.startsWith("http") && item.link?.includes(".")){
                    item.link=`https://${item.link}`
                }
            }


            if (item.delete) {
                editor.commands.unsetLink()
            } else {
                editor.commands.setLink({href: item, target: '_blank'})
                // setTimeout(() => {
                //     window.hookATags();
                // }, 600)
            }
        })
    }


    // 输入内容改变
    function handleEditorChange (value) {
        console.log('handleChange', value);
        setMdContent(value);
        clearTimeout(mTimeoutId.current);
        //读取这个文件，然后设置...
        let szFileDir = localStorage.getItem(KEY_FILE_DIR);
        let szFilePath = props.element.customData.generationData.fileName;
        if (!props.element.customData.generationData.isAbsolutePath){
            szFilePath = szFileDir + szFilePath;
        }
        window.globalRefreshList('onUpdateMdContent_'+props.element.id,value);

        mTimeoutId.current = setTimeout(()=>{
            //保存...
            ipcInvoke('write-file-absolute-path-text',{filePath:szFilePath,data:value});
        },2000);
    }
    // 保存输入内容
    function handleEditorSave (value) {
        console.log('handleEditorSave', value);
    }
    /**
     * md编辑
     */
    const renderMdEditor = ()=>{
        return <div style={{width:'100%',height:'100%',padding:'0 20px'}} className={'dialog-tiptap-text-editor-md'}>
            <MdEditor placeholder={''} toolbar={toolbar} value={mdContent} lineNum={0}
                      onChange={handleEditorChange} preview={isMdSplitView} subfield={isMdSplitView} onSave={handleEditorSave}/>
        </div>
    }

    const renderTextEditor = ()=>{
        return <div style={{width:'100%',height:'100%',padding:'0 20px'}} className={'dialog-text-'}>
            <textarea ref={mInputRef} style={{resize:'none',width:'100%',height:'100%'}} value={data?.name} onInput={(e)=>{
                const data1 = {...data}
                data1.name = e.currentTarget.value;
                setData(data1);
            }} onBlur={(e)=>{
                //更新数据...
                updateCard(data).then(res=>{
                    window.globalRefreshList('refresh_tableview_single_data_gridview_',res.id);
                })
            }}/>
        </div>
    }

    /**
     * 渲染界面
     */
    const renderHtml = ()=>{
        if(isMdFileElement(props.element)){
            return renderMdEditor()
        }else if (props.element?.type == 'row'){
            return renderTextEditor();
        }else{
            return renderTiptapEditor()
        }
    }

    /**
     * tiptap编辑器....
     */
    const renderTiptapEditor = ()=> {
        return <div ref={divContainerRef}
                    className={`div-placeholder dialog-tiptap-text-editor ${style.EditorStyle}` /*+ ((props.element.customData.generationData.isEditable)?'':'scrollbar-transparent')*/}
                    id={'div-cardedit-scroll-' + props.element.id}
                    onScroll={(event) => {
                        // if (!props.element?.customData?.generationData?.isEditable) {
                        //     event.preventDefault();
                        //     event.currentTarget.scrollTop = (mapDivScroll[props.element.id] || 0);
                        // }else {
                        //     mapDivScroll[props.element.id] = event.currentTarget.scrollTop;
                        // }
                        postMessage(EVENT_CLOSE_IMAGE_ACTION);
                    }}
                    onMouseDown={(event) => {
                        global.g_isCanvasCardMouseDown = true;
                    }}

                    style={{
                        overflowX: 'hidden',
                        overflowY: 'auto',
                        zIndex: '2006',
                        height: '100%',
                        // clipPath:'inset(16px 0px 6px 0px)',
                        scrollbarColor: 'transparent',
                        padding: '0px 10px',
                        scrollbarGutter: 'stable'  //这个属性很重要，使滚动条提前占位！！！！！！！！！滚动条滚动条滚动条滚动条滚动条滚动条滚动条滚动条
                    }}>

            {
                editor && (
                    <BubbleMenu editor={editor}
                                shouldShow={() => {
                                    if (!mEditor.current) return false;
                                    if (Global.g_isPresentMode) return false;
                                    if (global.g_isFromHeadClicked) {
                                        global.g_isFromHeadClicked = false;
                                        return false;
                                    }
                                    const {from, to} = mEditor.current.state.selection;
                                    let szName = mEditor.current.state.selection.node?.type?.name;
                                    if ('deeplink' == szName || 'youtube' == szName || 'latexBlock' == szName) return false;
                                    if (to != from) {
                                        return true;
                                    }
                                    return false;
                                }}
                                tippyOptions={{duration: 200, hideOnClick: true, maxWidth: '700px'}}>
                        <div className={style.action} style={{display: 'grid', gridTemplateColumns: 'repeat(14,auto)'}}>
                            <Dropdown overlayStyle={{zIndex: MAX_Z_INDEX}} menu={{
                                items: [
                                    {
                                        label: t('Text'),
                                        key: ''
                                    }, {
                                        label: t('H1'),
                                        key: 1
                                    }, {
                                        label: t('H2'),
                                        key: 2
                                    }, {
                                        label: t('H3'),
                                        key: 3
                                    }, {
                                        label: t('H4'),
                                        key: 4
                                    }, {
                                        label: t('H5'),
                                        key: 5
                                    }, {
                                        label: t('H6'),
                                        key: 6
                                    }, {
                                        label: t('Todo'),
                                        key: 7
                                    }, {
                                        label: t('Number list'),
                                        key: 8
                                    }, {
                                        label: t('Bullet list'),
                                        key: 9
                                    }
                                ], async onClick(event) {
                                    const e = Number(event.key)
                                    // 判断当前是不是list节点 转文本
                                    const {from} = editor.state.selection
                                    const resolvedPos = editor.state.doc.resolve(from);
                                    const currentNode = resolvedPos.node();
                                    const parentNode = resolvedPos.node(resolvedPos.depth - 1);

                                    // debugger
                                    if ([1, 2, 3, 4, 5, 6].includes(e)) {
                                        editor.chain().focus().setHeading({level: e, id: generateUUID2()}).run()
                                    } else if (e === 7 && parentNode.type.name !== 'taskItem') {
                                        editor
                                            .chain()
                                            .focus()
                                            .toggleTaskList()
                                            .run()
                                    } else if (e === 8 && !(parentNode.type.name === 'listItem' && resolvedPos.depth - 2 > -1 && resolvedPos.node(resolvedPos.depth - 2).type.name === 'orderedList')) {
                                        // 如果是自己类型地list转过来需要检验 不通过
                                        // 如果是非自己类型地list转过来需要检验 通过
                                        // 如果是非list 通过
                                        editor
                                            .chain()
                                            .focus()
                                            .toggleOrderedList()
                                            .run()
                                    } else if (e === 9 && !(parentNode.type.name === 'listItem' && resolvedPos.depth - 2 > -1 && resolvedPos.node(resolvedPos.depth - 2).type.name === 'bulletList')) {
                                        editor
                                            .chain()
                                            .focus()
                                            .toggleBulletList()
                                            .run()
                                    } else if (e === 0) {
                                        if (parentNode.type.name === 'listItem' || parentNode.type.name === 'taskItem') {
                                            const grandNode = resolvedPos.node(resolvedPos.depth - 2);
                                            if (grandNode.type.name === 'orderedList') {
                                                editor
                                                    .chain()
                                                    .focus()
                                                    .toggleOrderedList()
                                                    .run()
                                            } else if (grandNode.type.name === 'bulletList') {
                                                editor
                                                    .chain()
                                                    .focus()
                                                    .toggleBulletList()
                                                    .run()
                                            } else if (grandNode.type.name === 'taskList') {
                                                editor
                                                    .chain()
                                                    .focus()
                                                    .toggleTaskList()
                                                    .run()
                                            }

                                        } else {
                                            editor.chain().focus().setParagraph().run()
                                        }
                                    }
                                }
                            }}>
                                <div className='flex-row-vertical-center' style={{
                                    marginLeft: '0px',
                                    paddingLeft: '6px',
                                    width: '100%',
                                    whiteSpace: 'nowrap'
                                }}>
                  <span>
                    {editor.isActive('heading', {level: 1}) ? 'H1' :
                        editor.isActive('heading', {level: 2}) ? 'H2' :
                            editor.isActive('heading', {level: 3}) ? 'H3' :
                                editor.isActive('heading', {level: 4}) ? 'H4' :
                                    editor.isActive('heading', {level: 5}) ? 'H5' :
                                        editor.isActive('heading', {level: 6}) ? 'H6' :
                                            editor.isActive('bulletList') ? t('Bullet list') :
                                                editor.isActive('orderedList') ? t('Number list') :
                                                    editor.isActive('taskList') ? t('Todo') : t('Text')
                    }
                  </span>
                                    <img className='img-28' style={{marginTop: '-2px'}}
                                         src={getImagePathWithTheme('note_tool_dropdown')}/>

                                </div>
                            </Dropdown>

                            <div className={'line-card-h-split'}></div>

                            <div
                                className={editor.isActive("bold") ? style.act : null}
                                onClick={() => editor.chain().focus().toggleBold().run()}
                                title={t("Bold")}
                            >
                                {/*<TextBold theme="outline" size="16" fill="#333" />*/}
                                <img className='img-28'
                                     src={getImagePathWithTheme('note_tool_bold' + (editor.isActive("bold") ? '_selected' : ''))}/>
                            </div>
                            <div
                                className={editor.isActive("italic") ? style.act : null}
                                onClick={() => editor.chain().focus().toggleItalic().run()}
                                title={t("Italic")}
                            >
                                {/*<TextItalic theme="outline" size="16" fill="#333" />*/}
                                <img className='img-28'
                                     src={getImagePathWithTheme('note_tool_italic' + (editor.isActive("italic") ? '_selected' : ''))}/>
                            </div>
                            <div
                                className={editor.isActive("underline") ? style.act : null}
                                onClick={() => editor.chain().focus().toggleUnderline().run()}
                                title={t("Underline")}
                            >
                                {/*<TextUnderline theme="outline" size="16" fill="#333" />*/}
                                <img className='img-28'
                                     src={getImagePathWithTheme('note_tool_underline' + (editor.isActive("underline") ? '_selected' : ''))}/>
                            </div>
                            <div
                                className={editor.isActive("strike") ? style.act : null}
                                onClick={() => editor.chain().focus().toggleStrike().run()}
                                title={t("Strokethrough")}
                            >
                                {/*<Strikethrough theme="outline" size="16" fill="#333"/>*/}
                                <img className='img-28'
                                     src={getImagePathWithTheme('note_tool_strikethrough' + (editor.isActive("strike") ? '_selected' : ''))}/>
                            </div>
                            <div
                                className={
                                    editor.isActive({textAlign: "center"}) ? style.act : null
                                }
                                onClick={() =>
                                    editor.isActive({textAlign: "center"})
                                        ? editor.chain().focus().setTextAlign("left").run()
                                        : editor.chain().focus().setTextAlign("center").run()
                                }
                                title={t("Align")}
                            >
                                {/*<AlignTextCenter theme="outline" size="16" fill="#333" />*/}
                                <img className='img-28'
                                     src={getImagePathWithTheme('note_tool_align' + (editor.isActive({textAlign: "center"}) ? '_selected' : ''))}/>
                            </div>

                            <div
                                className={editor.isActive('code') ? style.act : null}
                                onClick={() => {
                                    editor.chain().focus().toggleCode().run()
                                }}
                                title={t("InlineCode")}
                            >
                                <img className='img-28'
                                     src={editor.isActive('code') ? getImagePathWithSvg('node_tool_code_block_selected') : getImagePathWithThemeSvg('node_tool_code_block')}/>
                            </div>

                            <div className={'line-card-h-split'}></div>
                            <div className={'flex-row-vertical-center'} style={{margin: '0 9px 0 14px', display: 'flex'}}>
                                <ColorPickers editor={editor}/>
                            </div>

                            {
                                !isInSingleFloatWindow() &&
                                <>
                                    <div className={'line-card-h-split'}></div>
                                    <div
                                        className={
                                            editor.getAttributes('link').href ? style.act : null
                                        }
                                        onClick={() => {
                                            showLink();
                                        }}>
                                        {/*<LinkIcon theme="outline" size="16" fill="#333" />*/}
                                        <img className='img-20'
                                             src={getImagePathWithTheme('card_bubble_menu_link' + (editor.getAttributes('link').href ? '_selected' : ''))}/>
                                    </div>

                                    <div className={'line-card-h-split'}></div>
                                    <div style={{
                                        margin: '0 6px 0 0',
                                        display: 'flex',
                                        width: '100%',
                                        cursor: 'pointer',
                                        paddingRight: '0px'
                                    }}>
                                        <TurnNewCard editor={editor}/>
                                    </div>
                                </>
                            }
                        </div>
                    </BubbleMenu>
                )}


            <EditorContent ref={mEditorContentRef} id={'editcontent-' + props.element.id}
                           className="tableStyle katex"
                           style={{
                               padding: '0px 0px',
                               // marginBottom: '16px',
                               textAlign: 'left',
                               width: 'calc(100% + 8px)',
                               height: '100%',
                               fontSize: `${props.element.fontSize}px`,
                               color: 'var(--text-color)',
                               fontFamily: getFontFamily()
                           }} editor={editor}/>

            <ImgAction editor={editor}/>
        </div>
    }

    /**
     * 标题图标.
     */
    const getIcon = ()=>{
        if(isStickyNotesElement(props.element)){
            return 'dialog_edit_stickynote';
        }else if (isTextElement(props.element)){
            return 'dialog_edit_text';
        }else if (isMdFileElement(props.element)){
            return 'dialog_edit_md'
        }else if (props.element.type == 'row'){
            return 'dialog_edit_text';
        }
        return '';
    }

    const getTitle = ()=>{
        if (isTextElement(props.element)){
            return t('Text editor');
        }else if (isStickyNotesElement(props.element)){
            return t('Sticky note editor')
        }else if (isMdFileElement(props.element)){
            return t('Markdown editor')
        }else if (props.element.type == 'row'){
            return t('Text editor');
        }
        return '';
    }
    return (
        <Modal keyboard={!isPin} width={dialogSize.width} zIndex={props.element?.zIndex} mask={hasMaskLayer}
               open={props.element?.open} closable={false} maskClosable={true} closeIcon={<IconClose/>} footer={null} onCancel={(e) => {
                   if (document.activeElement?.className == 'ant-modal-wrap'){
                       setIsShowDialog(false);
                       props.onCloseCallback(props.element);
                   }
        }} style={{
            minWidth: (dialogSize.width) + 'px',
            margin: '0px',
            left: x + 'px',
            top: y + 'px',
            paddingBottom: '0px',
            // opacity:isVisible?'1':'0',
            display: isVisible ? '' : 'none'
        }} styles={{
            wrapper: {
                overflow: "hidden",
                borderRadius: 0,
                pointerEvents: isPin ? 'none' : 'all',
            },
            content: {
                width: (dialogSize.width) + 'px',
                height: (dialogSize.height) + "px",
                borderRadius: 10,
                padding: '0px 0px 16px 0px'
            }
        }} modalRender={(modal) => (
            <div className={'div-no-margin'} id={'drag-' + props.element?.id} ref={draggleRef} onMouseDown={(event) => {
                event.stopPropagation();
                if (!getIsPin()) return;
                if (!event.target?.classList?.contains('div-dialog-tiptap-text-editor-header')) return;

                mIsDragging.current = true;
                offset.current.x = event.clientX - draggleRef.current.getBoundingClientRect().left;
                offset.current.y = event.clientY - draggleRef.current.getBoundingClientRect().top;
                setPointerEvents('none');
            }} onMouseMove={(event) => {
                if (mIsDragging.current) {
                    setX(event.clientX - offset.current.x);
                    setY(event.clientY - offset.current.y);
                }
            }} onMouseUp={(event) => {
                mIsDragging.current = false;
                setPointerEvents('all');
            }} style={{}} onClick={(event) => {
                event.stopPropagation();
                window.bringDialogTiptapTextEditorFront(data);
            }}>
                {modal}

                {/* 四个拖拽手柄 */}
                {
                    getIsPin() &&
                    <>
                        <div className="resize-handle top-left" onMouseDown={handleMouseDown('top-left')}/>
                        <div className="resize-handle top-right" onMouseDown={handleMouseDown('top-right')}/>
                        <div className="resize-handle bottom-left" onMouseDown={handleMouseDown('bottom-left')}/>
                        <div className="resize-handle bottom-right" onMouseDown={handleMouseDown('bottom-right')}/>
                        <div className="resize-handle left" onMouseDown={handleMouseDown('left')}/>
                        <div className="resize-handle right" onMouseDown={handleMouseDown('right')}/>
                        <div className="resize-handle top" onMouseDown={handleMouseDown('top')}/>
                        <div className="resize-handle bottom" onMouseDown={handleMouseDown('bottom')}/>
                    </>
                }

                {/* 你的内容 */}
            </div>
            // </Draggable>
        )}>
            <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                <div id={''} className={'div-dialog-tiptap-text-editor-header'} style={{margin: '0px'}}>
                    <div className={'flex-row-vertical-center div-dialog-tiptap-text-editor-header'}
                         style={{flexShrink: '0', margin: '16px 20px 0px 20px'}}>
                        <img className={'img-32'} style={{marginTop: '-2px', pointerEvents: 'none'}}
                             src={getImagePathWithThemeSvg(getIcon())}/>
                        <span className={'dialog-title'}
                              style={{pointerEvents: 'none'}}>{getTitle()}</span>
                        <div style={{flexGrow: '1'}}/>
                        {
                            isMdFileElement(props.element) &&
                            <Tooltip
                                     title={t('Split View')}
                                     zIndex={MAX_Z_INDEX}
                                     arrow={false}>
                                <img className='img-32 hovered-gray-radius ml-8' onClick={(event) => {
                                    event.stopPropagation();
                                    setIsMdSplitView(!isMdSplitView);
                                }}
                                     src={getImagePathWithTheme('dialog_edit_md_preview.svg')}/>
                            </Tooltip>
                        }
                        {
                            <>
                                <Tooltip overlayClassName='font-size-12'
                                         title={isPin ? t("UnpinFloatWindow") : t("PinAsFloatWindow")}
                                         zIndex={MAX_Z_INDEX}
                                         arrow={false}>
                                    <img className='img-32 hovered-gray-radius ml-8' onClick={(event) => {
                                        event.stopPropagation();
                                        setTimeout(() => {
                                            const nPinCount = window.getDialogPinCount();
                                            if (nPinCount > 0) {
                                                setHasMaskLayer(false);
                                            } else {
                                                setHasMaskLayer(isPin);
                                            }
                                        }, 100);
                                        setIsPin(!isPin);
                                    }}
                                         src={getImagePathWithTheme(isPin ? 'dialog_unpin.svg' : 'dialog_card_new_pin.svg')}/>
                                </Tooltip>
                            </>
                        }


                        <img className='img-32 cursor-pointer hovered-gray-radius ml-8'
                             src={getImagePathWithTheme('dialog_edit_close.svg')}
                             onClick={(event) => {
                                 event.stopPropagation();
                                 props.onCloseCallback(props.element);
                             }}/>

                    </div>
                </div>

                <div className={'line mt-6'}></div>


                <div className={'mt-12 flex-center'}
                     style={{
                         width: '100%',
                         flexGrow: '1',
                         overflow: 'hidden',
                         height: '100%',
                         position: 'relative'  // 添加相对定位
                     }}>
                    {
                        renderHtml()
                    }
                </div>

            </div>
        </Modal>
    )
})

export default DialogTiptapTextEditor;